import { Pipe, PipeTransform } from '@angular/core';
import { StatusWorkflowTypeItem } from 'src/app/api/models';
import { enumWorkflowType } from '../../utils/models/workflow.model';

@Pipe({
  name: 'workflowTypePipe',
})
export class WorkflowTypePipe implements PipeTransform {
  transform(value: StatusWorkflowTypeItem): string {
    switch (value.id) {
      case enumWorkflowType.ORDER:
        return 'Ordini fornitori';
      case enumWorkflowType.TICKET:
        return 'Ticket';
      case enumWorkflowType.CUSTOMER_ORDER:
        return 'Ordini clienti';
      case enumWorkflowType.DELIVERY:
        return 'Consegne';
      default:
        return 'Unknown Type';
    }
  }
}
